import React from 'react';
import { QuestionShort } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) => (
  <QuestionShort
    {...props}
    audioSource={generateUrl(file_audio_id)}
  />
);